
import {Component, Prop, Vue} from 'vue-property-decorator';
import {TakipAcStatusEnum} from '@/plugins/uyap-plugin/takip_ac/parser/TakipAcStatusEnum';
import {UYAP_ENGEL_KAPISI_MESAJI} from '@/plugins/uyap-plugin/UyapEngeli';
import {xmlSorguEngelMesaji} from '@/utils/uyapEngelDongu';

/**
 * "Dosyalar Sorgulanıyor" adımı: UYAP engelinde sorgulanmayan (QUERY_PENDING) dosyaların özeti ve "Kalanı sorgula"
 * düğmesi (DEV-3572, SOZLESME §8.1 #23). TakipHazirlaniyor ve MtsTakipHazirlaniyor ortak kullanır.
 *
 * Özet: "N/M dosya sorgulandı, K dosya UYAP engeli nedeniyle sorgulanmadı." (N = M - K). Düğme panel kilidi sürerken
 * PASİF (ipucu kapı metni), kilit kalkınca (reaktif ayna) etkinleşir; tıklanınca `kalani-sorgula` yayınlanır
 * (sorguyu sihirbaz yapar: yalnız QUERY_PENDING satırları sorgular, XML'i yeniden yüklemek gerekmez).
 */
@Component({})
export default class EngelSorguUyarisi extends Vue {
  @Prop({type: Array, default: () => []}) readonly dosyalar!: Array<{ status: TakipAcStatusEnum }>;
  @Prop({type: Boolean, default: false}) readonly onFly!: boolean;
  @Prop({type: Boolean, default: false}) readonly isParsing!: boolean;

  kapiMetni = UYAP_ENGEL_KAPISI_MESAJI;

  get sorgulanmayanSayisi(): number {
    return this.dosyalar.filter(d => d.status === TakipAcStatusEnum.QUERY_PENDING).length;
  }

  get ozet(): string {
    return xmlSorguEngelMesaji(this.dosyalar.length, this.sorgulanmayanSayisi);
  }

  get panelEngeliAktif(): boolean {
    return this.$store.getters.uyapEngeliPanelAktif === true;
  }
}
